import { render, staticRenderFns } from "./deleteseedlingInspection.vue?vue&type=template&id=2d6edd2b&scoped=true&"
import script from "./deleteseedlingInspection.vue?vue&type=script&lang=ts&"
export * from "./deleteseedlingInspection.vue?vue&type=script&lang=ts&"
import style0 from "./deleteseedlingInspection.vue?vue&type=style&index=0&id=2d6edd2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6edd2b",
  null
  
)

export default component.exports